import { cn } from "@/lib/utils";
import { useState, useEffect } from "react";
import { BACKEND_URL } from "@/lib/apiClient";

export function logoSrc(url) {
  if (!url) return null;
  return url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;
}

// Returns a background colour safe for white text: dark brand colours pass through,
// light ones are darkened toward a rich shade of the same hue.
export function themeBg(hex) {
  if (!hex || typeof hex !== "string") return "#0F172A";
  const h = hex.replace("#", "");
  if (h.length !== 6) return "#0F172A";
  let r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  if ([r, g, b].some((v) => Number.isNaN(v))) return "#0F172A";
  const lum = 0.299 * r + 0.587 * g + 0.114 * b;
  if (lum > 110) {
    const factor = 70 / lum;
    r = Math.round(r * factor); g = Math.round(g * factor); b = Math.round(b * factor);
  }
  return `rgb(${r}, ${g}, ${b})`;
}

// Company branding logo. Falls back to the company name when no logo is set OR the image fails to load.
export function BrandLogo({ company, dark = false, className = "h-7" }) {
  const src = logoSrc(company?.logo_url);
  const name = company?.name || "KQM Electrical";
  const [errored, setErrored] = useState(false);
  useEffect(() => { setErrored(false); }, [src]);
  if (src && !errored) {
    const img = <img src={src} alt={name} onError={() => setErrored(true)} className={cn("object-contain", className)} data-testid="brand-logo-img" />;
    return dark ? <span className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5">{img}</span> : img;
  }
  return (
    <span data-testid="brand-logo-text" className={cn("font-heading font-black tracking-tight leading-none text-lg", dark ? "text-white" : "text-slate-900")}>
      {name}
    </span>
  );
}
